export default __webpack_public_path__ + "static/media/user-joined.b3bc44c8.mp3";